<template>
  <div class="message-actions" :class="{ 'is-visible': isVisible }" @click.stop>
    <ActionMenu :menu-options="menuOptions" icon-type="kebab" :no-background="true" />
  </div>
</template>

<script lang="ts">
import ActionMenu from '@/components/action_menu/ActionMenu.vue';
import CopyIcon from '@/graphics/icons/CopyIcon.vue';
import type { MenuItemOptions } from '@/components/action_menu/__types__/ActionMenuTypes';

export default {
  name: 'MessageBubbleActions',
  components: {
    ActionMenu,
  },
  props: {
    messageBody: {
      type: String,
      required: true,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    menuOptions(): MenuItemOptions[] {
      return [
        {
          icon: CopyIcon,
          labelText: 'Copy',
          closeOnClick: true,
          click: this.copyToClipboard,
        },
      ];
    },
  },
  methods: {
    async copyToClipboard(): Promise<void> {
      try {
        await navigator.clipboard.writeText(this.messageBody);
        this.$emit('copied');
      } catch (err) {
        console.error('Failed to copy text:', err);
      }
    },
  },
};
</script>

<style scoped>
.message-actions {
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.2s ease,
    visibility 0.2s ease;
  position: relative;
  z-index: 10;
  flex-shrink: 0;
}

.message-actions.is-visible {
  opacity: 1;
  visibility: visible;
}
</style>
